"use client"

import PostLink from "@/components/PostLink"
import { formatDateSimple, toImageSrc } from "@/lib/utils"
import Image from "next/image"
import { LatestNewsArticle } from "../types"

interface FeaturedArticleProps {
  article: LatestNewsArticle
}

const FeaturedArticle = ({ article }: FeaturedArticleProps) => {
  return (
    <PostLink
      href={`/${article.slug}`}
      locale={article.locale}
      postId={article.id}
      className="group block relative overflow-hidden rounded-lg"
    >
      <div className="relative w-full h-[400px]">
        {article.imageUrl && (
          <Image
            src={toImageSrc(article.imageUrl)}
            alt={article.title}
            fill
            className="object-cover transition-transform duration-300 group-hover:scale-105 image-hover"
          />
        )}

        {/* Overlay */}
        <div className="absolute top-0 left-0 w-full h-full rounded-lg bg-[linear-gradient(0deg,rgba(0,0,0,0.85),transparent)]" />

        {/* Content */}
        <div className="flex flex-col sm:gap-2.5 gap-[6px] absolute top-[250px] sm:left-[56px] left-[10px] sm:right-[56px] right-[10px]">
          {article.categoryName && (
            <div className="sm:text-xs sm:leading-[18.6px] text-lg leading-[27.9px] font-bold text-[#1AAF4D]">
              {article.categoryName}
            </div>
          )}
          <h2 className="sm:text-xl sm:leading-[31px] text-base leading-[24.8px] font-bold text-white line-clamp-3 transition-all duration-300 group-hover:text-[#18af4e]">
            {article.title}
          </h2>
          <div className="text-base leading-[24.8px] font-medium text-white">
            {formatDateSimple(article.publishedAt)}
          </div>
        </div>
      </div>
    </PostLink>
  )
}

export default FeaturedArticle
